import {
    AddMonthFee,
    AddNormalUseFee,
    DeleteFeeRecord,
    DeleteMonthFee,
    DeleteReimburse,
    QueryAreaFee,
    QueryAreaOther,
    QueryExpenseFee,
    QueryExpenseFeeInfo,
    QueryExpenseRecordInfo,
    QueryFeeCustomer,
    QueryFeeDetail,
    QueryFeeOther,
    QueryGationInfo,
    QueryMainFee,
    QueryMonthFee,
    QueryMonthFeeDetail,
    QueryMonthFeeDetailInfo,
    QueryUserFee,
    SaveAreaFee,
    SaveUserFee,
    UpdateFeeVerfiyFlag,
    UpdateMonthFee,
    UpdateNormalUseFee,
    UpdateUserFee
} from '@/request/fee';
import store from '..';
import { AddUseFee, UpdateUseFee, UpdateUseFeeResult } from '../../request/fee';

export default {
    namespace: true,
    state: {
        feeCustomer: []
    },
    mutations: {
        SET_FEE_CUSTOMER(state, feeCustomer) {
            state.feeCustomer = feeCustomer;
        }
    },
    actions: {
        QUERY_FEE_CUSTOMER: async ({ commit }, payload) => {
            let res = await QueryFeeCustomer(payload);
            return res;
        },
        QUERY_FEE_DETAIL: async ({}, payload) => {
            let res = await QueryFeeDetail(payload);
            return res;
        },

        QUERY_MONTH_FEE: async ({}, payload) => {
            let res = await QueryMonthFee(payload);
            return res;
        },
        ADD_MONTH_FEE: async ({}, payload) => {
            let res = await AddMonthFee(payload);
            return res;
        },
        UPDATE_MONTH_FEE: async ({}, payload) => {
            let res = await UpdateMonthFee(payload);
            return res;
        },
        DELETE_MONTH_FEE: async ({}, payload) => {
            let res = await DeleteMonthFee(payload);
            return res;
        },
        QUERY_MONTH_FEE_DETAIL: async ({}, payload) => {
            let res = await QueryMonthFeeDetail(payload);
            return res;
        },
        QUERY_MONTH_FEE_DETAIL_INFO: async ({}, payload) => {
            let res = await QueryMonthFeeDetailInfo(payload);
            return res;
        },

        QUERY_MAIN_FEE: async ({}, payload) => {
            let res = await QueryMainFee(payload);
            return res;
        },

        // 已花费用
        ADD_USE_FEE: async ({}, payload) => {
            let res = await AddUseFee(payload);
            return res;
        },
        ADD_NORMAL_USE_FEE: async ({}, payload) => {
            let res = await AddNormalUseFee(payload);
            return res;
        },
        UPDATE_USE_FEE: async ({}, payload) => {
            let res = await UpdateUseFee(payload);
            return res;
        },

        UPDATE_NORMAL_USE_FEE: async ({}, payload) => {
            let res = await UpdateNormalUseFee(payload);
            return res;
        },
        UPDATE_USE_FEE_RESULT: async ({}, payload) => {
            let res = await UpdateUseFeeResult(payload);
            return res;
        },

        QUERY_FEE_OTHER: async ({}, payload) => {
            let res = await QueryFeeOther(payload);
            return res;
        },

        QUERY_AREA_OTHER: async ({}, payload) => {
            let res = await QueryAreaOther(payload);
            return res;
        },

        // 区域费用
        QUERY_AREA_FEE: async ({}, payload) => {
            let res = await QueryAreaFee(payload);
            return res;
        },
        SAVE_AREA_FEE: async ({}, payload) => {
            let res = await SaveAreaFee(payload);
            return res;
        },

        //个人费用
        QUERY_USER_FEE: async ({}, payload) => {
            let res = await QueryUserFee(payload);
            return res;
        },
        UPDATE_USER_FEE: async ({}, payload) => {
            let res = await UpdateUserFee(payload);
            return res;
        },
        SAVE_USER_FEE: async ({}, payload) => {
            let res = await SaveUserFee(payload);
            return res;
        },

        QUERY_EXPENSE_FEE: async ({}, payload) => {
            let res = await QueryExpenseFee(payload);
            return res;
        },

        QUERY_EXPENSE_FEE_INFO: async ({}, payload) => {
            let res = await QueryExpenseFeeInfo(payload);
            return res;
        },

        QUERY_EXPENSE_RECORD_INFO: async ({}, payload) => {
            let res = await QueryExpenseRecordInfo(payload);
            return res;
        },

        QUERY_GATION_INFO: async ({}, payload) => {
            let res = await QueryGationInfo(payload);
            return res;
        },

        UPDATE_FEE_VERIFY_FLAG: async ({}, payload) => {
            let res = await UpdateFeeVerfiyFlag(payload);
            return res;
        },

        DELETE_FEE_RECORD: async ({}, payload) => {
            let res = await DeleteFeeRecord(payload);
            return res;
        }
    }
};
